import {createContext} from 'react';

export const HookContext = createContext({})

export const UserContext = createContext({});

export const MapContext = createContext({});

export const AdminContext = createContext({});
